import classNames from 'classnames';
import {
	DishAssignmentContext,
	IDishAssignmentContext,
} from 'modules/Menu/Dishes/DishAssignment/dishAssignmentState/dishAssignmentContext';
import React, { useContext, useEffect } from 'react';
import CategoryCrumb from './components/CategoryCrumb';
import SubcategoryCrumb from './components/SubcategoryCrumb';
import DishCrumb from './components/DishCrumb';
import style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const containerClasses = classNames(style.container, { [style.hidden]: !isShowBreadcrumbs });

	const emptyCategories = !Object.keys(IDsSelectedCategories).length;

	useEffect(() => {
		emptyCategories && setShowBreadcrumbs(false);
	}, [emptyCategories]);

	return (
		<div className={containerClasses} data-test="Breadcrumbs">
			<CategoryCrumb />
			<SubcategoryCrumb />
			<DishCrumb />
		</div>
	);
};

export default Breadcrumbs;
